// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
enum Dimensions {
    BIG = '645X430',
    SMALL = '354X255'
}

export function mapListingImage(dto) {
    return {
        src: dto.firstPropertyImage[Dimensions.BIG],
        caption: dto.firstPropertyImage.caption,
        responsiveImgList: [
            {
                width: 480,
                src: dto.firstPropertyImage[Dimensions.SMALL]
            },
            {
                width: 960,
                src: dto.firstPropertyImage[Dimensions.BIG]
            }
        ]
    };
}

export function mapOtherPropertyImages(dto) {
    return (dto.otherPropertyImages || []).map((i) => ({
        ...i,

        small: i[Dimensions.SMALL],
        large: i[Dimensions.BIG],
        caption: i.caption
    }));
}
